import { ManualTitle } from '../../component/ManualTitle';
import ManualPageList from '../../component/ManualPageList';
import ManualCategoryMaintenancePlan from '../../component/ManualCategoryMaintenancePlan';

export const ManualMaintenancePlan004: React.FC = () => {
  return (
    <>
      <ManualTitle
        id="manual-004"
        SubTitle={['かんたんメンテナンス', <br key="key" />, 'プラン']}
      ></ManualTitle>
      <ManualCategoryMaintenancePlan id="manual-004"></ManualCategoryMaintenancePlan>
      <section className="section-common">
        <div className="container has-background-white">
          <h3
            className="common-category-header has-text-weight-bold has-text-centered"
            id="about"
          >
            かんたんメンテナンスプラン
            <br />
            について
          </h3>
          <h4 className="common-section-header has-text-centered has-text-weight-bold">
            かんたんメンテナンスプランでできること
          </h4>
          <div className="inner">
            <h5 className="common-text-header has-text-weight-bold">
              車検・法定12ヶ月点検
            </h5>
            <p className="is-margin-top-7">
              指定の整備工場と日程をご調整のうえ、法定12ヶ月点検と車検をお受けいただけます。あわせてエンジンオイルなど消耗品の交換も実施します。点検時期の約2～3ヶ月前にメール等でご案内いたします。
            </p>
            <h5 className="common-text-header has-text-weight-bold has-text-border">
              <p>原状回復費用補償</p>
            </h5>
            <p className="is-margin-top-7">
              リース期間後の車両返却時に、車両の損耗や損傷による修理/修繕/原状回復費等の精算が発生した際の費用を上限金額まで補償します。
            </p>
            <h5 className="common-text-header has-text-weight-bold has-text-border">
              <p>延長保証</p>
            </h5>
            <p className="is-margin-top-7">
              メーカー保証が終了した後に、同程度の保証を提供します。
            </p>
            <a
              href="https://carmo-kun.jp/docs/maintenance/new/kantan_maintenance_v1.pdf"
              className="is-margin-top-7 button-base-arrow has-text-weight-bold has-text-black button-orange"
            >
              メンテナンスプラン<br />サービス資料はこちら
            </a>
            <p className="common-back-category has-text-right is-margin-top-7 has-text-border">
              <a href="#category" className="has-text-black">
                カテゴリ選択に戻る
              </a>
            </p>
          </div>
          <h3
            className="common-category-header has-text-weight-bold has-text-centered"
            id="invoice"
          >
            ご点検の流れ
          </h3>
          <h4 className="common-section-header has-text-centered has-text-weight-bold">
            ご点検の流れ（法定12ヶ月点検、車検）
          </h4>
          <div className="inner">
            <ul className="common-step is-margin-top-4">
              <li className="is-flex is-mobile">
                <p className="common-step-flow">
                  点検時期の
                  <br />
                  お知らせ
                </p>
                <div className="common-step-text">
                  カーリースカルモくんより、法定12ヶ月点検、車検の点検時期について、それぞれ約2～3ヶ月前にメール等でお知らせいたします。
                </div>
              </li>
              <li className="is-flex is-mobile">
                <p className="common-step-flow">
                  指定の整備工場と点検日のご調整
                </p>
                <div className="common-step-text">
                  指定の整備工場と点検日のご調整をしていただきます。
                  <br />
                  転居をされた場合は工場の変更が必要となりますので、必ず
                  <a href="#footer">カーリースカルモくんサポートデスク</a>
                  までご連絡ください。
                </div>
              </li>
              <li className="is-flex is-mobile">
                <p className="common-step-flow">点検の実施</p>
                <div className="common-step-text has-text-weight-bold">
                  点検日当日にお車をご指定工場にお持ち込みいただき、点検をお受けください
                </div>
              </li>
            </ul>
          </div>
          <div className="inner">
            <h5 className="common-text-header has-text-weight-bold">
              指定工場について
            </h5>
            <p className="is-margin-top-7">
              ご契約時にカーリースカルモくんよりご案内を差し上げた工場となります。ご転居をされた場合は、工場を転居先のお近くに変更いたしますので、
              <a href="#footer">カーリースカルモくんサポートデスク</a>
              までご連絡ください。新しい工場はご連絡をいただいた後、10日前後でご案内します。
            </p>
            <h5 className="common-text-header has-text-weight-bold has-text-border">
              <p>点検費用について</p>
            </h5>
            <p className="is-margin-top-7">
              ご加入プランに定められている点検項目の費用はカーリースカルモくんにて負担いたします。定められていない項目の点検を実施された場合は自費でのご負担となります。
            </p>
            <h5 className="common-text-header has-text-weight-bold has-text-border">
              <p>指定工場以外で点検を受けた場合について</p>
            </h5>
            <p className="is-margin-top-7">
              点検費用は全額自費でのご負担となります。
            </p>
            <h5 className="common-text-header has-text-weight-bold has-text-border">
              <p>メンテナンスプランの途中加入について</p>
            </h5>
            <p className="is-margin-top-7">
              車検満了後60日以内であれば途中加入いただけます。
            </p>
            <h5 className="common-text-header has-text-weight-bold has-text-border">
              <p>
                かんたんメンテナンスプランからどこでもメンテナンスプランへの切替について
              </p>
            </h5>
            <p className="is-margin-top-7">
              特別な事情を除いて切替はできかねます。
            </p>
          </div>
        </div>
      </section>
      <ManualPageList id="manual-004"></ManualPageList>
    </>
  );
};
